/**
 * @file   src\Pages\AddLocation.tsx
 * @brief  AddLocation page.
 * @date   JUL, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, useState, useEffect, Container, Breadcrumb, useNavigate, useOutletContext, useParams } from '../utils/thirdpartyComponents';
import "../styles/subscriptions.scss";
import AddlocationWrapper from '../components/AddlocationWrapper';
import { pageURLs } from '../utils/pageUrls';
import { AppContextType } from '../interfaces/generalInterface';
import axios from '../config/axiosConfig';
import { CompanyApi } from "../utils/apiUrls";
import { userType } from '../utils/enums';

const AddLocation = (props: any) => {

    const param = useParams();
    const current_carwash_id = param.id ? parseInt(param.id) : 0;

    // State to company details
    const [company, setCompany] = useState({
        companyName: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zipCode: ""
    });

    // Fetch company information on component mount
    useEffect(() => {
        if (props.userType !== userType['CARWASH-OWNER']) {
            getCompanyAddress();
        }
    }, []);

    // To get company details
    const getCompanyAddress = async () => {
        try {
            const param3 = `${current_carwash_id}`;
            const { data } = await axios.get(CompanyApi.GET_COMPANY_ADDRESS + param3)
            if (data?.error === 0) {
                setCompany(data.data);
            }

        } catch (error: any) {
            throw new Error(error.response?.data?.message || error.message);
        }
    }

    // Access the context
    const { updateData } = useOutletContext<AppContextType>();

    const navigate = useNavigate()


    // To display heading
    useEffect(() => {
        handleUpdate()
    }, [company])

    // Update the data
    const handleUpdate = () => {
        updateData({ heading: "Add Location", url: props.userType === userType['CARWASH-OWNER'] ? `/${pageURLs.carwash_locations}` : `/superadmin/${pageURLs.carwash_locations}/${current_carwash_id}`, showBackButton: true, showMainMenu: true, activeLink: props.userType === userType['CARWASH-OWNER'] ? "manage-car-wash-locations" : "manage-car-wash" });
    };

    // Navigate accordung to url
    const itemClick = async (url: string) => {
        navigate(url);
    }
    return (

        <div className='manage-subscription-container'>
            <Container>
                <Breadcrumb>
                    {props.userType === userType['CARWASH-OWNER'] ? null : <Breadcrumb.Item onClick={() => { itemClick(`/superadmin/${pageURLs.manage_carwash}`) }}>Manage Car Washes</Breadcrumb.Item>}
                    <Breadcrumb.Item 
                        onClick={() => { 
                            if (props.userType === userType['CARWASH-OWNER']) { 
                            itemClick(`/${pageURLs.carwash_locations}`); 
                            } else { 
                            itemClick(`/superadmin/${pageURLs.carwash_locations}/${current_carwash_id}`);
                            } 
                        }} 
                        >
                        {props.userType === userType['CARWASH-OWNER'] ? "Manage Car Wash Locations" : company.companyName}
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>Add Location</Breadcrumb.Item>
                </Breadcrumb>

                <div className='cw-form-outer-wrap'>
                    <div className="cw-form-container">
                        <div className="add-location-wrap mx-auto">
                            <AddlocationWrapper cuserType={props.userType} />
                        </div>
                    </div>
                </div>

            </Container>
        </div>
    )
}

export default AddLocation;
